/* eslint-disable import/prefer-default-export */
/* eslint-disable react/prop-types */
import React from "react";
import * as dayjs from "dayjs";
import "dayjs/locale/en";
import "dayjs/locale/fr";
import { RCLProvider } from "./src/components/RCL";
import { AlertsProvider } from "./src/context";
import { SecurityProvider } from "./src/templates/user-account/context/SecurityProvider";
import { PageContextProvider } from "./src/components/PageContext";
import {
	EMAIL_COOKIE_NAME,
	EXIT_INTENT_COOKIE_NAME,
} from "./src/components/EmailAcquisitionForm/const";

/* global Genesys */
import "./src/styles/index.scss";

let genesysInitialized = false;
export const onRouteUpdate = ({ location }) => {
	// if ?hideGenesys=true is present in the URL, hide the Genesys Messenger
	const urlParams = new URLSearchParams(location.search);
	document.body.classList.toggle("hideGenesys", urlParams.get("hideGenesys") === "true");

	if (!window.Genesys || genesysInitialized) return;

	const genesysLauncher = document.getElementById("genesys-messenger");

	Genesys("subscribe", "Messenger.opened", () => {
		Genesys("command", "Database.set", {
			messaging: {
				customAttributes: {
					language: document.documentElement.lang || "en",
					pageURL: location.href,
					pagePath: location.pathname,
					pageTitle: document.title,
					referrer: document.referrer || null,
				},
			},
		});
		genesysLauncher.style.zIndex = 9999;
	});
	genesysInitialized = true;

	Genesys("subscribe", "Messenger.closed", () => {
		genesysLauncher.style.zIndex = 9998;
	});
};

// Wraps every page in a component
export const wrapPageElement = ({ element, props }) => {
	const lang = props?.pageContext?.locale?.substring(0, 2);
	dayjs.locale(lang === "fr" ? "fr" : "en");

	// Handle Fresh Relevance - Social Proof Banner
	if (!window.socialProofCallback) {
		window.socialProofCallback = () => {
			const socialTrendObj = document.querySelector(".social-trend-wrapper");
			const socialTrendClose = document.querySelector(".social-trend-close");

			const delay = duration =>
				new Promise(resolve => {
					setTimeout(() => resolve(), duration);
				});

			const hideSocialProof = (callback = () => {}) => {
				socialTrendObj.style.opacity = 0;
				delay(2000)
					.then(() => {
						socialTrendObj.style.display = "none";
					})
					.then(callback);
			};

			const handleCloseButton = e => {
				e.preventDefault();
				hideSocialProof();
			};

			if (socialTrendObj) {
				socialTrendObj.style.display = "block";
				delay(1000)
					.then(() => {
						socialTrendObj.style.opacity = 1;
						socialTrendClose.addEventListener("click", handleCloseButton);
					})
					.then(() => delay(7000))
					.then(() => {
						hideSocialProof(() => {
							socialTrendClose.removeEventListener("click", handleCloseButton);
						});
					});
			}
		};
	}

	// Reset any Email Acquistion / Exit Intent tracking
	if (window.sessionStorage) {
		sessionStorage.removeItem(EXIT_INTENT_COOKIE_NAME);
		sessionStorage.removeItem(EMAIL_COOKIE_NAME);
	}

	return (
		<SecurityProvider lang={props?.pageContext?.locale}>
			<PageContextProvider data={props?.pageContext}>
				<AlertsProvider
					lang={props?.pageContext?.locale}
					staticAlertsCount={props?.pageContext?.numberOfAlerts}
					timestamp={props?.pageContext?.timestamp}>
					<RCLProvider lang={props?.pageContext?.locale}>{element}</RCLProvider>
				</AlertsProvider>
			</PageContextProvider>
		</SecurityProvider>
	);
};
